// import { useState } from 'react';
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'


import Header from '../components/header'
import Footer from '../components/footer'
import useGaspAnimations from '../components/useGsapAnimations'

function Markets() {
     useGaspAnimations()
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)


    return(
       <section id="smooth-wrapper">
          <Header/>
          <main>
 

{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Our Markets</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Markets</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start services page area--> */}
<section className="services-page-area">
    <div className="container">
        <div className="row">
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/01.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/01.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Food</h3>
                        <p>Refrigeration solutions to ensure food freshness and safety.</p>
                        <a href="/market-food">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/02.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/02.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Dairy</h3>
                        <p>Energy-efficient refrigeration systems</p>
                        <a href="/market-dairy">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/03.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/07.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Industrial HVAC</h3>
                        <p>We custom-engineer HVAC for industrial and commercial applications.</p>
                        <a href="/market-HVAC">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/04.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                            <img src='assets/images/Marketicons/03.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Beverage</h3>
                        <p>Reliable refrigeration for efficient beverage manufacturing and quality.</p>
                        <a href="/market-beverage">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/05.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                              <img src='assets/images/Marketicons/04.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Pharma</h3>
                        <p>Precise refrigeration for pharmaceutical safety and compliance
</p>
                        <a href="/market-pharma">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
            {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/06.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                              <img src='assets/images/Marketicons/05.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Oil / Gas / Chemical / Power</h3>
                        <p>Robust refrigeration for the oil, gas, and chemical industries.</p>
                        <a href="/market-oil-gas-chemical">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

             {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/Market-Images/07.webp" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                               <img src='assets/images/Marketicons/06.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>Cold Storage & WareHouse</h3>
                        <p>Integrated cold storage for temperature-sensitive goods</p>
                        <a href="/market-Cold-Storage-and-WareHouse">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}

               {/* <!--Start single item--> */}
            <div className="col-md-4 bdFadeUp">
                <div className="single-item">
                    <div className="img-holder">
                        <img src="assets/images/OurProducts/Negative-Storage-722x368.jpg" alt="Awesome Image"/>
                        <div className="iocn-holder">
                            {/* <span className="flaticon-construction"></span>     */}
                          <img src='assets/images/Marketicons/08.webp' alt='icons'/>
                        </div>
                    </div>
                    <div className="text-holder">
                        <h3>General Industries</h3>
                        <p>Industrial refrigeration plays a critical role across a wide range of general industrial sectors</p>
                        <a href="/market-General-Industries">Read More<i className="fa fa-angle-right" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
            {/* <!--End single item--> */}
        </div>
    </div>
</section>

 {/* <!--Start appoinment area--> */}
              
                    {/* <!--End appoinment area--> */}
{/* <!--End services page area--> */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Markets;


